<template>
    <div class="corporate-login">
        <Header />
        <b-row class="pt-5">
            <b-col cols="12" md="8" lg="4" offset-md="2" offset-lg="4">
                <b-card>
                    <h2 class="text-center">{{ $t('corporate_login') }}</h2>
                    <hr>

                    <b-form @submit.prevent="login" class="mt-5">
                        <b-form-input :placeholder="$t('login_name')" class="roundeds mt-3" v-model="user.name" required></b-form-input>
                        <b-form-input :placeholder="$t('password')" class="roundeds mt-3" v-model="user.password" type="password" required></b-form-input>
                        <p class="text-lightgreen text-right pt-3" @click="openContactAdminPopup"><span class="link">{{ $t('contact_admin') }}</span></p>
                        <b-button variant="success" type="submit" :disabled="loading" class="py-3 mt-4" block>{{loading ? $t('please_wait') : $t('login')}}</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <b-modal :title="$t('contact_admin')" v-model="contactAdminModal" hide-footer centered>
            <p> <b>{{$t('contact_admin_content')}} </b> </p>
            <p> <b>{{$t('admin_phone')}} </b> <a :href="'tel:' + this.admin_phone">{{admin_phone}}</a></p>
            <p> <b>{{$t('admin_email')}} </b> <a :href="'mailto:' + this.admin_email">{{admin_email}}</a></p>
        </b-modal>
    </div>
</template>

<script>
import Header from '@/components/Header'
export default {
    name: "CorporateLogin",
    components: {
        Header
    },
    created() {
        this.redirectUser();
    },
    data() {
        return {
            loading: false,
            contactAdminModal: false,
            admin_phone: "27869009",
            admin_email: "info@oshmi.org",
            user: {
                name: null,
                password: null
            }
        }
    },
    methods: {
        async login() {
            this.loading = true
            const resp = await this.$store.dispatch('loginCorporate', this.user)
            this.loading = false

            if(resp === 1) {
                this.move('/booking')
                // window.location.href = window.location.href.split('corporate-login')[0]+'booking'
            }
            
        },
        openContactAdminPopup() {
            this.contactAdminModal = true;
        }
    }
}
</script>